import tw from "twin.macro"

export const Container = tw.div`relative`
export const ContentWithPadding = tw.div`max-w-screen-xl mx-auto py-4 lg:py-8`
export const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-10 lg:py-12`
export const ContentWithPaddingLg = tw.div`max-w-screen-lg mx-auto py-16 lg:py-20`
export const ContentWithVerticalPadding = tw.div`py-16 lg:py-20`
export const Content2Xl = tw.div`max-w-screen-2xl mx-auto`
